export default __webpack_public_path__ + "static/media/Caen-La-Mer.f3344670.jpg";